import { useLocation } from 'react-router-dom'
import warehouseIcon from '../../../_supplier/assets/media/dashboard/warehouse.svg'
import {
  ALL_WAREHOUSES_OPTION,
  useWarehouse,
} from '../../context/WarehouseContext'
import { CustomSelect } from '../select/CustomSelect'

const FILTER_PLACEHOLDER = 'Filter By Warehouse'

const WarehouseFilter = () => {
  const {
    selectedWarehouses,
    setSelectedWarehouse,
    warehouseOptions,
    warehouseList,
    loading: warehouseLoading,
  } = useWarehouse()

  const selectedValue = selectedWarehouses[0] ?? ALL_WAREHOUSES_OPTION
  const isAllSelected = selectedValue.value === ALL_WAREHOUSES_OPTION.value

  const handleWarehouseChange = (selected: any) => {
    const nextSelected = selected ?? ALL_WAREHOUSES_OPTION
    if (nextSelected.value === selectedValue.value) return
    setSelectedWarehouse(nextSelected)
  }

  if (warehouseList.length === 0) return null

  return (
    <div className='warehouse-filter group flex items-stretch overflow-hidden rounded-xl border border-[#d6e4f5] bg-white shadow-[0_1px_3px_rgba(27,116,228,0.08)] transition-all duration-200 hover:border-[#9fc2ef] hover:shadow-[0_4px_14px_rgba(27,116,228,0.12)] focus-within:border-[#1b74e4] focus-within:shadow-[0_0_0_3px_rgba(27,116,228,0.12)]'>
      <div className='flex shrink-0 items-center gap-2.5 border-r border-[#e8f0fa] bg-gradient-to-b from-[#f7faff] to-[#eef5ff] px-3.5'>
        <span
          className={`flex h-8 w-8 items-center justify-center rounded-lg transition-colors duration-200 ${
            isAllSelected
              ? 'bg-[#1b74e4]/10 text-[#1b74e4]'
              : 'bg-[#1b74e4] text-white'
          }`}
        >
          <img
            src={warehouseIcon}
            alt=''
            aria-hidden='true'
            className={`h-4 w-4 ${isAllSelected ? 'opacity-90' : 'brightness-0 invert'}`}
          />
        </span>
        <div className='hidden min-w-0 sm:block'>
          <p className='mb-0 text-[10px] font-semibold uppercase tracking-[0.08em] text-[#7a90a8]'>
            Filter by
          </p>
          <p className='mb-0 text-[13px] font-semibold leading-tight text-[#1a2b3c]'>
            Warehouse
          </p>
        </div>
      </div>

      <div className='min-w-[200px] flex-1 lg:min-w-[280px]'>
        <CustomSelect
          backgroundColor='transparent'
          border='transparent'
          minHeight='48px'
          minWidth='100%'
          radiusTable='0'
          controlFontSize='1.077rem'
          value={selectedValue}
          onChange={handleWarehouseChange}
          hideSelectedOptions={false}
          options={warehouseOptions}
          isLoading={warehouseLoading}
          placeholder={FILTER_PLACEHOLDER}
          isClearable={false}
        />
      </div>
    </div>
  )
}

const WarehouseFilterBar = () => {
  const location = useLocation()
  const { warehouseList } = useWarehouse()

  const isMasterModuleRoute =
    location.pathname.startsWith('/master') ||
    location.pathname.startsWith('/products')
  const isManageProfileRoute = location.pathname.startsWith(
    '/profile-management/manage-profile'
  )

  if (
    isMasterModuleRoute ||
    isManageProfileRoute ||
    warehouseList.length === 0
  ) {
    return null
  }

  return (
    <div className='shrink-0 flex justify-end border-b border-[#e4ecf5] bg-gradient-to-r from-[#f8fbff] via-white to-[#f0f6fc] px-9 py-3'>
      <WarehouseFilter />
    </div>
  )
}

export { WarehouseFilter, WarehouseFilterBar }
